<template>
  <div>
      <div v-if="!hasChildren">
      <!-- HEAD -->

          <div class="head row p-0 g-0">
                <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 p-0"  data-aos="fade-right" data-aos-duration="500">
                  <img :src="`${publicPath}img/02water.jpg`" class="img-responsive">
                </div>
                <div class="headRight py-3 py-md-0 py-lg-5" data-aos="fade-right" data-aos-delay="400" data-aos-duration="200">
                  <h1 class="my-3 my-lg-0 my-xl-3 my-xxl-5">02</h1>
                  <h2 class="my-3 my-lg-0 my-xl-3" v-html="$t('water.fundacion')"></h2>
                  <p class="text-end pt-2 pt-md-3 pt-xl-3">{{ $t('water.difusion') }}</p>
                </div>
          </div>
      <!-- end HEAD -->

          <div class="contingut bg-white row g-0">
              <div class="row g-0">
                  <div class="col-12 col-lg-10 m-auto pt-5 mt-5">
                      <img :src="`${publicPath}img/logoWeAreWater.png`" class="img-responsive" data-aos="fade" data-aos-easing="linear" data-aos-duration="1000">
                      <p class="text-turquesa p-1 pt-3 mx-0 mx-md-5">{{ $t('water.nacimiento') }}</p>
                      <hr class="bg-darkBlue">
                  </div>
                  <div class="col-12 col-lg-10 m-auto">
                      <div class="row g-0">
                          <div class="col-12 col-lg-6 py-0 py-lg-5 mb-0 mb-lg-5 pe-0 pe-lg-3">
                              <localized-link class="footerLink" to="/fundacion-we-are-water/proyectos-de-cooperacion">
                              <h3 class="text-turquesa py-5">{{ $t('water.proyectos') }}</h3>
                              <img :src="`${publicPath}img/02waterProyectos.jpg`" class="img-responsive" data-aos="fade" data-aos-easing="linear" data-aos-duration="1000">
                              </localized-link>
                          </div>
                          <div class="col-12 col-lg-6 py-5 ps-0 ps-lg-3">
                              <localized-link class="footerLink" to="/fundacion-we-are-water/acciones-de-concienciacion">
                              <h3 class="text-turquesa py-5">{{ $t('water.concienciacion') }}</h3>
                              <img :src="`${publicPath}img/02waterAcciones.jpg`" class="img-responsive" data-aos="fade" data-aos-easing="linear" data-aos-duration="1000">
                              </localized-link>
                          </div>
                          <div class="col-12 m-auto mb-5 bg-darkBlue">
                              <div class="row g-0">
                                  <div class="col-12 col-lg-6 p-1 py-5 p-lg-5 text-center text-xl-start">
                                      <h4 class="text-turquesa">{{ $t('water.apoyo') }}</h4>
                                      <p class="text-white">{{ $t('water.apoyo_txt') }}</p>
                                      <a :href="link_ukr" target="_blank">{{ $t('water.donativo') }}
                                          <span class="btnCollapseIn btnClar ms-3 external-link-light"><i class="fa-solid fa-link"></i></span>
                                      </a>
                                  </div>
                                  <div class="col-12 col-lg-6 text-end p-0 bg-foto" :style="{ backgroundImage: `url(${publicPath}img/02waterWarMeans.jpg)` }"></div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <hr class="mt-5">
              <div class="row p-0 g-0">
                  <div class="col-12 p-3 p-lg-0 m-0 pb-3 pb-lg-5 text-end">
                      <localized-link class="footerLink" to="/fundacion-we-are-water/proyectos-de-cooperacion">{{ $t("nav.proyectos-de-cooperacion") }} <img :src="`${publicPath}img/breadcrumbGo.gif`" class="img-responsive" width="6"></localized-link>
                  </div>
              </div>

          </div>

      </div>
      <router-view></router-view>
  </div>
</template>

<script>
    export default {
        props: {
          hasChildren: Boolean
        },
        data() {
            return {
              publicPath: process.env.BASE_URL,
              link_ukr: 'https://www.wearewater.org/es/implicate_253022'
            }
        },
        mounted() {
          if(this.$i18n.locale=="en"){
            this.link_ukr = 'https://www.wearewater.org/en/get-involved_253022 ';
          }
      }
    }
</script>
